import { createPromiseClient } from "@apachedubbo/dubbo";
import { TriPartnerFlowService } from "@onetakesolutions/cargogo-contract-web/TriPartnerFlowService_dubbo";
import transport from "./transport";

const client = createPromiseClient(TriPartnerFlowService, transport, {
  serviceGroup: "dubbo",
  serviceVersion: "1.0.0",
});

export default client;
